import { Outlet } from "react-router-dom";

export const AuthLayout = () => (
  <div className='auth-layout'>
    <main>
      <Outlet />
    </main>
  </div>
);
